import api from '@/api/fetchClient'

export default {
  uploadExpenses(file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.postFormData('expenses/bulk-upload', formData, { authorized: true })
  }
}
